// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Layout, { Container } from "../components/layout";
// import { Bar, Line } from "react-chartjs-2";
// import { apiurl } from "../config/config";
// import { useUser } from "../config/userProvider";
// import Card from "../components/card";
// import { useNavigate } from "react-router-dom";
// import { BlackButton } from "../components/buttonContainer";
// import Input from "../components/inputContainer";
// // import { getCookie } from "../config/webStorage";
// // import { LocationData } from "./locationdata";
// // import { Link } from "react-router-dom";
// // import Storepopup from "../components/storepopup";
// // import SegmentedDonutChart from "./segmentedDonutChart";
// // import SegmentedTrafficBar from "./segmentedTrafficBar";
// // import BackHeader from "../components/backHeader";
// // import { CountryData, StateData } from "../constants/constant";
// // import { RxCross2 } from "react-icons/rx";
// // import { Doughnut, Pie } from "react-chartjs-2";
// // import {
// //   FaStore,
// //   FaCalendarAlt,
// //   FaGlobe,
// //   FaMapMarkerAlt,
// //   FaCity,
// // } from "react-icons/fa";
// import { InfiLoader } from "../components/loader";

// function Insight() {
//   const {
//     userData,
//     // storeData,
//     // getstoresLoading,
//     // setCloseProfile,
//     // permissions,
//   } = useUser();
//   // const token = getCookie("bb_token");
//   let vendorObjId = userData?.vendorDetails?.vendorObjId;

//   const [loading, setLoading] = useState(false);
//   const [parentFilterData, setParentFilterData] = useState("");
//   const [selectedDate, setSelectedDate] = useState("");
//   const [filter, setFilter] = useState("catalog_generated");
//   const [filterData, setFilterData] = useState("");
//   const [filterLoading, setFilterLoading] = useState(false);
//   // const [isPopupOpen, setPopupOpen] = useState(false);
//   // const [todayCount, setTodayCount] = useState("00");
//   // const [totalpdf, SetTotalPdf] = useState("00");
//   // const [selectedRange, setSelectedRange] = useState("today");
//   // const [startDate, setStartDate] = useState("");
//   // const [endDate, setEndDate] = useState("");
//   // const [AnalyticsData, setAnalyticsData] = useState("");
//   // const [loadingData, setLoadingData] = useState(false);
//   // const [catalogStatus, setCatalogStatus] = useState("");
//   // const [timeType, setTimeType] = useState("");
//   // const [selectedState, setSelectedState] = useState("");
//   // const [selectedCity, setSelectedCity] = useState("");
//   const [selectedCountry, setSelectedCountry] = useState("");

//   const [advanceFilterData, setAdvanceFilterData] = useState({
//     catalogStatus: "catalog_generated",
//     timeType: "",
//     selectedCountry: "",
//     selectedState: "",
//     selectedCity: "",
//     startDate: "",
//     endDate: "",
//     week: "",
//     month: "",
//     quarter: "",
//     year: "",
//   });
//   console.log("ADVANCE FILTER DATA : ", advanceFilterData);
//   const navigate = useNavigate();

//   // const handleCountryChange = (e) => {
//   //   setSelectedCountry(e.target.value);
//   //   setSelectedState("");
//   //   setSelectedCity("");
//   // };

//   // const handleStateChange = (e) => {
//   //   setSelectedState(e.target.value);
//   //   setSelectedCity("");
//   // };

//   // const handleInputChange = (e) => {
//   //   const { name, value } = e.target;
//   //   setAdvanceFilterData((prevState) => ({
//   //     ...prevState,
//   //     [name]: value,
//   //   }));
//   // };

//   // const handleCityChange = (e) => {
//   //   setSelectedCity(e.target.value);
//   // };
//   // const { countries, states, cities } = LocationData;

//   // const trafficData = {
//   //   title: "Website Traffic",
//   //   subtitle: "Unique visitors",
//   //   totalVisitors: 26751,
//   //   segments: [
//   //     { label: "Direct", value: 14750, color: "#1f77b4" },
//   //     { label: "Organic", value: 8000, color: "#2ca02c" },
//   //     { label: "Referral", value: 2500, color: "#ff7f0e" },
//   //     { label: "Social", value: 1500, color: "#d62728" },
//   //   ],
//   // };

//   useEffect(() => {
//     filterHandler();
//   }, []);

//   const filterHandler = () => {
//     setFilterLoading(true);
//     if (selectedDate === "" || filter === "") {
//       setLoading(true);
//     }
//     const todayDate = new Date().toISOString().split("T")[0];

//     let data = JSON.stringify({
//       vendorObjId: vendorObjId,
//       type: filter || "catalog_generated",
//       date: selectedDate || todayDate,
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/analytic/insight`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         if (response.data.success === true) {
//           // setLeaderBoardData(response.data.data);
//           // setFilterBy(response.data.data)
//           // setLoader(false);
//           console.log("RESPONSE IS:", response?.data?.data);
//           setFilterData(response.data.data);
//           setLoading(false);
//           setFilterLoading(false);
//         }
//       })
//       .catch((error) => {
//         setLoading(false);
//         setFilterLoading(false);
//         console.log(error);
//       });
//     // }
//   };
//   const advanceFilterHandler = () => {
//     navigate("/analytics/report");
//     // console.log("advanceFilterData", advanceFilterData)

//     // setFilterLoading(true);
//     // if (selectedDate === "" || filter === "") {
//     //   setLoading(true);
//     // }
//     // const todayDate = new Date().toISOString().split('T')[0];

//     // let data = JSON.stringify({
//     //   vendorObjId: vendorObjId,
//     //   type: filter || "catalog_generated",
//     //   date: selectedDate || todayDate,
//     // });

//     // let config = {
//     //   method: "post",
//     //   maxBodyLength: Infinity,
//     //   url: `${apiurl}/admin/v1/analytic/report`,
//     //   headers: {
//     //     "Content-Type": "application/json",
//     //   },
//     //   data: data,
//     // };

//     // axios
//     //   .request(config)
//     //   .then((response) => {
//     //     if (response.data.success === true) {
//     //       // setLeaderBoardData(response.data.data);
//     //       // setFilterBy(response.data.data)
//     //       // setLoader(false);
//     //       console.log("RESPONSE IS:", response?.data?.data)
//     //       setFilterData(response.data.data);
//     //       setLoading(false);
//     //       setFilterLoading(false);

//     //     }
//     //   })
//     //   .catch((error) => {
//     //     // setLoader(false);
//     //     setLoading(false);
//     //     setFilterLoading(false);
//     //     console.log(error);
//     //   });
//     // }
//   };

//   // useEffect(() => {
//   //   if (selectedRange !== "customDate") {
//   //     filterHandler();
//   //   }
//   // }, [selectedRange]);

//   const data = {
//     labels: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"],
//     datasets: [
//       {
//         label: "Product 1",
//         data: [12, 19, 7, 15, 10], // Custom data for Product 1
//         fill: true,
//         tension: 0.2,
//         backgroundColor: "rgba(255, 99, 132, 0.2)",
//         borderColor: "rgba(255, 99, 132, 1)",
//       },
//       {
//         label: "Product 2",
//         data: [8, 15, 11, 20, 14], // Custom data for Product 2
//         fill: true,
//         tension: 0.2,
//         backgroundColor: "rgba(54, 162, 235, 0.2)",
//         borderColor: "rgba(54, 162, 235, 1)",
//       },
//       {
//         label: "Product 3",
//         data: [14, 10, 13, 12, 16], // Custom data for Product 3
//         fill: true,
//         tension: 0.2,
//         backgroundColor: "rgba(255, 206, 86, 0.2)",
//         borderColor: "rgba(255, 206, 86, 1)",
//       },
//       {
//         label: "Product 4",
//         data: [10, 14, 18, 22, 25], // Custom data for Product 4
//         fill: true,
//         tension: 0.2,
//         backgroundColor: "rgba(75, 192, 192, 0.2)",
//         borderColor: "rgba(75, 192, 192, 1)",
//       },
//       {
//         label: "Product 5",
//         data: [5, 8, 12, 10, 7], // Custom data for Product 5
//         fill: true,
//         tension: 0.2,
//         backgroundColor: "rgba(153, 102, 255, 0.2)",
//         borderColor: "rgba(153, 102, 255, 1)",
//       },
//     ],
//   };
//   // Ensure filterData is available before defining storeData
//   // let storeData = { labels: [], datasets: [] };

//   // if (filterData) {
//   //   storeData = {
//   //     labels: filterData?.stores?.map((store) => store?.storeName || "Unknown"),
//   //     datasets: [
//   //       {
//   //         label: "Store Count",
//   //         data: filterData?.stores?.map((store) => store?.count),
//   //         backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"], // Example colors for the chart
//   //         borderWidth: 1,
//   //       },
//   //     ],
//   //   };
//   //   console.log("storeData", storeData);
//   // }

//   let storeData = { labels: [], datasets: [] };

//   if (filterData) {
//     // Map the actual store data
//     const stores =
//       filterData?.stores?.map((store) => ({
//         label: store?.storeName || "Unknown",
//         count: store?.count || 0,
//       })) || [];

//     // Ensure a minimum of 5 data entries with "xyz" placeholders
//     while (stores.length < 5) {
//       stores.push({ label: "xyz", count: 0 });
//     }

//     storeData = {
//       labels: stores.slice(0, 5).map((store) => store.label), // Limit to max 5 entries
//       datasets: [
//         {
//           label: "Store Count",
//           data: stores.slice(0, 5).map((store) => store.count),
//           backgroundColor: [
//             "#FF6384",
//             "#36A2EB",
//             "#FFCE56",
//             "#4BC0C0",
//             "#9966FF",
//           ], // Extend colors for 5 entries
//           borderWidth: 1,
//         },
//       ],
//     };
//     console.log("storeData", storeData);
//   }

//   // You can now safely use storeData inside your JSX or elsewhere

//   // --------------FILTERD POPUP BY TYPE --------------------------
//   const [popUpType, setPopUpType] = useState("");
//   const [isOpenFiler, setIsOpenFiler] = useState(false);
//   const [filterdStores, setFilterdStores] = useState("");
//   const [chooseFilteredBy, setChooseFilteredBy] = useState("");

//   useEffect(() => {
//     setFilterdStores("");
//     // trigger when pop have clicked
//     if (popUpType && ["admin", "superadmin"].includes(userData?.userType)) {
//       let data = JSON.stringify({
//         vendorObjId: vendorObjId,
//         type: popUpType,
//       });

//       let config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: `${apiurl}/admin/v1/analytic/report/store/action`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: data,
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           if (response.data.success === true) {
//             console.log(
//               JSON.stringify("filterdStores filterdStores", response.data)
//             );
//             setFilterdStores(response.data.data);
//           }
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     } else if (popUpType && userData?.userType === "user") {
//       const axios = require("axios");
//       let data = JSON.stringify({
//         vendorObjId: vendorObjId,
//         type: popUpType,
//         userObjId: "672ca793304906035e939401",
//       });

//       let config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: `${apiurl}/admin/v1/analytic/report/user`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: data,
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           if (response.data.success === true) {
//             console.log(JSON.stringify("filterdStores user ", response.data));
//             setFilterdStores(response.data.data);
//           }
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }
//   }, [popUpType]);

//   const [stateFilter, setStateFilter] = useState("");

//   // const handleCountryChange = (e) => {
//   //   const country = e.target.value;
//   //   setSelectedCountry(country);
//   // };

//   useEffect(() => {
//     if (stateFilter) {
//       StateFilterHandler();
//     }
//   }, [stateFilter]);

//   const StateFilterHandler = () => {
//     let data = JSON.stringify({
//       vendorObjId: vendorObjId,
//       type: popUpType,
//       province_code: "UP",
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/analytic/report/state/action`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         if (response.data.success === true) {
//           console.log(JSON.stringify("filterdStores State", response.data));
//           setFilterdStores(response.data.data);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   const filterBy = (e) => {
//     setFilter(e.target.value);
//   };

//   const [showFilterPopUp, setShowFilterPopUp] = useState(false);

//   // const filterHandler = () => {
//   //   navigate("/analytics/report")
//   // };

//   const Select = ({
//     children,
//     className,
//     label,
//     icon,
//     ContainerSubclassName,
//     ContainerClassName,
//     ...props
//   }) => (
//     <div className={`${ContainerClassName}`}>
//       {label && <Input.normal label={label} isInput={false} />}
//       <div
//         className={`${
//           ContainerSubclassName ? ContainerSubclassName : "py-2 px-2"
//         }cursor-pointer flex items-center w-full border  rounded-md gap-1`}
//       >
//         {icon && <span className="text-gray-500">{icon}</span>}
//         <select
//           className={`${className}  pr-4 outline-none block w-full sm:text-sm rounded-md `}
//           {...props}
//         >
//           {children}
//         </select>
//       </div>
//     </div>
//   );

//   return (
//     <Layout>
//       <Container>
//         {loading === true ? (
//           <InfiLoader maintext="Fetching Insight Details..." />
//         ) : (
//           <>
//             {/* {popUpType && (
//               <Card.AddPopUp removePopUp={() => setPopUpType("")}>
//                 <BackHeader
//                   title={popUpType.replace(/_/g, " ")}
//                   rightSide={
//                     <button
//                       onClick={() => setIsOpenFiler(!isOpenFiler)}
//                       className={`border border-zinc-700 rounded-md px-5 py-1`}
//                     >
//                       {isOpenFiler ? "X" : "Filter"}
//                     </button>
//                   }
//                 />

//                 {isOpenFiler && (
//                   <div className=" bg-zinc-50 rounded-md p-2 mt-4">
//                     <p className="block text-sm font-medium text-gray-700">
//                       Filterd by
//                     </p>
//                     <div className="flex justify-between md:flex-nowrap flex-wrap  gap-3">
//                       <select
//                         id="country"
//                         name="country"
//                         onChange={handleCountryChange}
//                         className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
//                       >
//                         <option value="">Select Country</option>
//                         {Object.entries(CountryData).map(([key, value]) => (
//                           <option key={key} value={key}>
//                             {value}
//                           </option>
//                         ))}
//                       </select>

//                       <select
//                         id="state"
//                         name="state"
//                         onChange={(e) => setStateFilter(e.target.value)}
//                         className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
//                       >
//                         <option value="">Select State</option>
//                         {Object.entries(StateData).map(([key, value]) => (
//                           <option key={key} value={key}>
//                             {value}
//                           </option>
//                         ))}
//                       </select>

//                       <select
//                         id="city"
//                         name="city"
//                         className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
//                       >
//                         <option value="">Select City</option>
//                       </select>

//                       <input
//                         type="date"
//                         id="date"
//                         name="date"
//                         className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
//                       />
//                     </div>
//                   </div>
//                 )}

//                 <div class="relative overflow-x-auto sm:rounded-lg mt-5">
//                   <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
//                     <thead className="text-xs text-gray-700 uppercase bg-gray-50  ">
//                       <tr>
//                         <th scope="col" className="px-6 py-3">
//                           Store Name
//                         </th>
//                         <th scope="col" className="px-6 py-3">
//                           Store Code
//                         </th>
//                         <th scope="col" className="px-6 py-3">
//                           Count
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {filterdStores &&
//                         filterdStores.map((store, index) => (
//                           <tr
//                             key={index}
//                             className="bg-white border-b hover:bg-gray-50 "
//                           >
//                             <th
//                               scope="row"
//                               className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
//                             >
//                               {store.storeName || "N/A"}
//                             </th>
//                             <td className="px-6 py-4">
//                               {store.storeCode || "N/A"}
//                             </td>
//                             <td className="px-6 py-4">{store.count}</td>
//                           </tr>
//                         ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </Card.AddPopUp>
//             )} */}

//             {/* {showFilterPopUp && (
//               <Card.AddPopUp
//                 ClassName="h-auto "
//                 removePopUp={() => setShowFilterPopUp(false)}
//               >
//                 <div className="capitalize flex flex-col gap-2 h-fit max-h-[90vh] overflow-scroll">
//                   <div className="flex items-center justify-between pb-2 ">
//                     <div className="text-lg font-semibold text-center flex-grow">Filter by time and date</div>
//                     <div
//                       className="flex items-center justify-center w-8 h-8 border rounded-full cursor-pointer hover:bg-gray-100"
//                       onClick={() => setShowFilterPopUp(false)}
//                     >
//                       <RxCross2 className="text-lg" />
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-3 gap-4 pt-3 mt-3 bg-slate-50 p-4 rounded-md">
//                     <label
//                       key="catalog_generated"
//                       className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
//                     >
//                       <input
//                         type="radio"
//                         name="catalogStatus"
//                         value="catalog_generated"
//                         className="form-radio text-blue-600"
//                         checked={advanceFilterData?.catalogStatus === "catalog_generated"}
//                         onChange={handleInputChange}
//                       />
//                       Catalog Generated
//                     </label>

//                     <label
//                       key="catalog_sent"
//                       className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
//                     >
//                       <input
//                         type="radio"
//                         name="catalogStatus"
//                         value="catalog_sent"
//                         className="form-radio text-blue-600"
//                         checked={advanceFilterData?.catalogStatus === "catalog_sent"}
//                         onChange={handleInputChange}
//                       />
//                       Catalog Sent
//                     </label>

//                     <label
//                       key="catalog_sent_email"
//                       className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
//                     >
//                       <input
//                         type="radio"
//                         name="catalogStatus"
//                         value="catalog_sent_email"
//                         className="form-radio text-blue-600"
//                         checked={advanceFilterData?.catalogStatus === "catalog_sent_email"}
//                         onChange={handleInputChange}
//                       />
//                       Catalog Sent Email
//                     </label>

//                     <label
//                       key="catalog_sent_whatsapp"
//                       className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
//                     >
//                       <input
//                         type="radio"
//                         name="catalogStatus"
//                         value="catalog_sent_whatsapp"
//                         className="form-radio text-blue-600"
//                         checked={advanceFilterData?.catalogStatus === "catalog_sent_whatsapp"}
//                         onChange={handleInputChange}
//                       />
//                       Catalog Sent WhatsApp
//                     </label>

//                     <label
//                       key="catalog_downloaded"
//                       className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
//                     >
//                       <input
//                         type="radio"
//                         name="catalogStatus"
//                         value="catalog_downloaded"
//                         className="form-radio text-blue-600"
//                         checked={advanceFilterData?.catalogStatus === "catalog_downloaded"}
//                         onChange={handleInputChange}
//                       />
//                       Catalog Downloaded
//                     </label>

//                     <label
//                       key="order_placed"
//                       className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
//                     >
//                       <input
//                         type="radio"
//                         name="catalogStatus"
//                         value="order_placed"
//                         className="form-radio text-blue-600"
//                         checked={advanceFilterData?.catalogStatus === "order_placed"}
//                         onChange={handleInputChange}
//                       />
//                       Order Placed
//                     </label>
//                   </div>

//                   <div className="w-full bg-slate-50 p-4 rounded-md">
//                     <div className="w-full">
//                       <label className="block text-sm font-medium text-gray-700 mb-1">Time</label>
//                       <Select
//                         value={advanceFilterData?.timeType}
//                         // onChange={(e) => setTimeType(e.target.value)}
//                         name="timeType"
//                         onChange={handleInputChange}
//                         className="block w-full bg-white  text-gray-700 rounded-md py-2 px-3 sm:text-sm"
//                         ContainerSubclassName="px-0 py-0"
//                       >
//                         <option value="" disabled>Select Duration</option>
//                         <option value="date">Date</option>
//                         <option value="range">Range</option>
//                         <option value="week">Week</option>
//                         <option value="month">Month</option>
//                         <option value="quarter">Quarter</option>
//                         <option value="year">Year</option>
//                       </Select>
//                     </div>
//                   </div>

//                   {advanceFilterData?.timeType && (
//                     <div className="p-3 bg-slate-50 rounded-lg  ">
//                       <Input.normal label={advanceFilterData?.timeType} isInput={false} />
//                       {advanceFilterData?.timeType === "date" && (
//                         <div className="flex gap-2">
//                           <input
//                             type="date"
//                             className="border p-2 rounded-lg w-full"
//                             placeholder="Date"
//                             name="date" // Bind to startDate in the state
//                             value={advanceFilterData.startDate}
//                             onChange={handleInputChange}
//                           />
//                         </div>
//                       )}
//                       {advanceFilterData?.timeType === "range" && (
//                         <div className="flex gap-2">
//                           <input
//                             type="date"
//                             className="border p-2 rounded-lg w-full"
//                             placeholder="Start Date"
//                             name="startDate" // Bind to startDate in the state
//                             value={advanceFilterData.startDate}
//                             onChange={handleInputChange}
//                           />
//                           <input
//                             type="date"
//                             className="border p-2 rounded-lg w-full"
//                             placeholder="End Date"
//                             name="endDate" // Bind to endDate in the state
//                             value={advanceFilterData.endDate}
//                             onChange={handleInputChange}
//                           />
//                         </div>
//                       )}
//                       {advanceFilterData?.timeType === "week" && (
//                         <input
//                           type="week"
//                           className="border p-2 rounded-lg w-full"
//                           placeholder="Select Week"
//                           name="week" // Bind to week in the state
//                           value={advanceFilterData.week}
//                           onChange={handleInputChange}
//                         />
//                       )}
//                       {advanceFilterData?.timeType === "month" && (
//                         <input
//                           type="month"
//                           className="border p-2 rounded-lg w-full"
//                           placeholder="Select Month"
//                           name="month" // Bind to month in the state
//                           value={advanceFilterData.month}
//                           onChange={handleInputChange}
//                         />
//                       )}
//                       {advanceFilterData?.timeType === "quarter" && (
//                         <select className="border p-2 rounded-lg w-full" name="quarter" // Bind to quarter in the state
//                           value={advanceFilterData.quarter}
//                           onChange={handleInputChange}>
//                           <option value="">Select Quarter</option>
//                           <option value="Q1">Jan-Mar</option>
//                           <option value="Q2">Apr-Jun</option>
//                           <option value="Q3">Jul-Sep</option>
//                           <option value="Q4">Oct-Dec</option>
//                         </select>
//                       )}
//                       {advanceFilterData?.timeType === "year" && (
//                         <select className="border p-2 rounded-lg w-full" name="year" // Bind to year in the state
//                           value={advanceFilterData.year}
//                           onChange={handleInputChange}>
//                           {Array.from({ length: 10 }, (_, index) => {
//                             const year = new Date().getFullYear() - index;
//                             return (
//                               <option key={year} value={year}>
//                                 {year}
//                               </option>
//                             );
//                           })}
//                         </select>
//                       )}
//                     </div>
//                   )}

//                   <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-slate-50 p-6 rounded-lg">
//                     <select
//                       value={advanceFilterData?.selectedCountry}
//                       // onChange={handleCountryChange}
//                       onChange={handleInputChange}
//                       className="border p-2 rounded-lg w-full"
//                       name="selectedCountry"
//                     >
//                       <option value="">Select Country</option>
//                       {countries.map((country) => (
//                         <option key={country.code} value={country.code}>
//                           {country.name}
//                         </option>
//                       ))}
//                     </select>

//                     <select
//                       value={advanceFilterData?.selectedState}
//                       // onChange={handleStateChange}
//                       onChange={handleInputChange}
//                       className="border p-2 rounded-lg w-full"
//                       disabled={!advanceFilterData?.selectedCountry}
//                       name="selectedState"
//                     >
//                       <option value="">Select State</option>
//                       {states[advanceFilterData?.selectedCountry]?.map((state) => (
//                         <option key={state.code} value={state.code}>
//                           {state.name}
//                         </option>
//                       ))}
//                     </select>

//                     <select
//                       value={advanceFilterData?.selectedCity}
//                       // onChange={handleCityChange}
//                       onChange={handleInputChange}
//                       className="border p-2 rounded-lg w-full"
//                       disabled={!advanceFilterData?.selectedState}
//                       name="selectedCity"
//                     >
//                       <option value="">Select City</option>
//                       {cities[advanceFilterData?.selectedState]?.map((city) => (
//                         <option key={city.code} value={city.code}>
//                           {city.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="flex justify-center mt-5 ">
//                     <BlackButton handleSubmit={advanceFilterHandler} title="Apply" />
//                   </div>
//                 </div>

//               </Card.AddPopUp>
//             )} */}

//             <div className="h-full">
//               {/* Filter Section */}
//               <FilterSection
//                 onClick={() => navigate("/analytics/report")}
//                 setParentFilterData={setParentFilterData}
//                 filterHandler={filterHandler}
//                 filterData={filterData}
//                 selectedDate={selectedDate}
//                 setSelectedDate={setSelectedDate}
//                 setSelectedCountry={setSelectedCountry}
//                 setFilter={setFilter}
//                 filter={filter}
//                 filterLoading={filterLoading}
//                 filterBy={filterBy}
//               />

//               <div className="flex flex-col gap-3 overflow-auto h-[78%] lg:h-[90%] pb-3">
//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-3  mt-3">
//                   {/* Top User Section */}
//                   {/* <div className="col-span-1 bg-white rounded-lg shadow-md p-3"> */}
//                   <TopUser
//                     title="Users"
//                     users={parentFilterData?.users}
//                   />
//                   {/* </div> */}

//                   {/* Active User in States */}
//                   {/* <div className="col-span-1 bg-white rounded-lg shadow-md p-3"> */}
//                   {/* <ActiveUserStates states={parentFilterData?.states} /> */}
//                   <TopStates title="States" states={parentFilterData?.states} />

//                   <div className="col-span-1">
//                     <TopProducts
//                       title="Products"
//                       products={parentFilterData?.products}
//                     />
//                   </div>

//                   {/* </div> */}

//                   {/* Empty Space for Future Use */}
//                   {/* <div className=" bg-white rounded-lg shadow-md p-3">
//                     <h2 className="text-xl font-semibold">Top Store</h2>
//                     <div
//                       className={`   rounded-lg w-full  bg-white/100  p-3 py-6`}
//                     >
//                       <Bar data={storeData} style={{ height: "", width: "" }} />
//                     </div>
//                   </div> */}
//                 </div>
//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 ">
//                   {/* <div className="col-span-1"> */}
//                   <TopCity
//                     title="Cities"
//                     cities={parentFilterData?.cities}
//                   />
//                   {/* </div> */}
//                   <div className="col-span-2">
//                     <div className=" bg-white rounded-lg shadow-md p-3">
//                       <h2 className="text-xl font-semibold">Stores</h2>
//                       <div className={`   rounded-lg w-full  bg-white/100`}>
//                         <Bar
//                           data={storeData}
//                           style={{ height: "", width: "" }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   {/* <div className="col-span-1">
//                     <TopUser title="Top Catalog" users={topUserData} />
//                   </div> */}
//                 </div>
//                 {/* <div className="grid grid-cols-1 lg:grid-cols-4 gap-3 ">
//                   <div className="col-span-2">
//                     <BarCart data={data} />
//                   </div>
//                   <div className="col-span-2">
//                     <BarCart data={data} />
//                   </div>
//                 </div> */}
//               </div>
//             </div>
//           </>
//         )}
//       </Container>
//     </Layout>
//   );
// }

// export default Insight;

// const StatCard = ({ label, value, key, onClick }) => (
//   <div
//     className="cursor-pointer hover:bg-zinc-100 text-center w-full shadow rounded-md bg-white drop-shadow-md py-3"
//     key={key}
//     onClick={onClick}
//   >
//     <p className="text-xs md:text-sm text-gray-500">{label}</p>
//     <p className="text-base md:text-lg font-semibold text-gray-800">{value}</p>
//   </div>
// );

// const FilterSection = ({
//   onClick,
//   setParentFilterData,
//   filterHandler,
//   filterData,
//   selectedDate,
//   setSelectedDate,
//   setFilter,
//   filter,
//   filterLoading,
//   setSelectedCountry,
//   filterBy,
// }) => {
//   let { userData } = useUser();

//   console.log("FILTER DATA", filterData);

//   const handleDateChange = (e) => {
//     setSelectedDate(e.target.value);
//   };

//   useEffect(() => {
//     setParentFilterData(filterData);
//   }, [filterData, setParentFilterData]);

//   return (
//     <div className="flex justify-between  bg-white p-4 rounded-lg shadow-md">
//       <div className="flex flex-col md:flex-row gap-4">
//         <div className="flex flex-row w-full justify-between gap-2">
//           <div className="border block cursor-pointer pl-2 lg:pl-3 pr-2 lg:pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm md:text-base rounded-md">
//             <input
//               className="outline-none h-full w-full "
//               placeholder="date"
//               type="date"
//               value={selectedDate}
//               onChange={handleDateChange}
//             />
//           </div>
//           <div className="flex gap-4 ">
//             <select
//               onChange={filterBy}
//               className="bg-white border border-gray-300 text-gray-700 text-sm md:text-base py-2 px-2 lg:px-4 rounded shadow-sm focus:outline-none capitalize"
//               value={filter}
//             >
//               <option value="">filter By</option>
//               <option value="order_placed">Orders</option>
//               <option value="catalog_generated"> Generated</option>
//               <option value="catalog_downloaded">Downloaded</option>
//               <option value="catalog_sent_email"> Mail</option>
//               <option value="catalog_sent_whatsapp">Whatsapp</option>
//             </select>
//           </div>
//         </div>
//         <div className="flex flex-row w-full gap-2 justify-start">
//           {(selectedDate || filter) && (
//             <BlackButton
//               title="Apply"
//               handleSubmit={filterHandler}
//               loading={filterLoading}
//               loadingTitle={"Applying ..."}
//               disabled={selectedDate === "" && filter === ""}
//             />
//           )}
//           <div className="md:hidden flex">
//             <BlackButton title="Advanced Filter" handleSubmit={onClick} />
//           </div>
//         </div>
//       </div>
//       <div className="hidden md:flex">
//         <BlackButton title="Advanced Filter" handleSubmit={onClick} />
//       </div>
//     </div>
//   );
// };

// const TopUser = ({ title, users }) => {
//   console.log(
//     "USERS IS ====================================>>>>>>>>>>>>>>>",
//     users
//   );
//   return (
//     <div className="bg-white rounded-lg shadow-md p-3">
//       <h2 className="text-xl font-semibold mb-4">{title}</h2>

//       <ul className="flex flex-col gap-2">
//         {users && users.length > 0 ? (
//           users.map((user, index) => (
//             <Card.StatCard
//               key={index}
//               label={user.userName}
//               value={user.count}
//               color="#00000010"
//             />
//           ))
//         ) : (
//           <img src="/dataNotFound.png" alt="Data not found" />
//         )}
//       </ul>
//     </div>
//   );
// };
// const TopStates = ({ title, states }) => {
//   console.log(
//     "States IS ====================================>>>>>>>>>>>>>>>",
//     states
//   );
//   return (
//     <div className="bg-white rounded-lg shadow-md p-3">
//       <h2 className="text-xl font-semibold mb-4">{title}</h2>

//       <ul className="flex flex-col gap-2">
//         {states && states.length > 0 ? (
//           states.map((state, index) => (
//             <Card.StatCard
//               key={index}
//               label={state?.state}
//               value={state?.count}
//               color="#00000010"
//             />
//           ))
//         ) : (
//           <img src="/dataNotFound.png" alt="Data not found" />
//         )}
//       </ul>
//     </div>
//   );
// };
// const TopCity = ({ title, cities }) => {
//   console.log(
//     "City IS ====================================>>>>>>>>>>>>>>>",
//     cities
//   );
//   return (
//     <div className="bg-white rounded-lg shadow-md p-3">
//       <h2 className="text-xl font-semibold mb-4">{title}</h2>

//       <ul className="flex flex-col gap-2">
//         {cities && cities.length > 0 ? (
//           cities.map((city, index) => (
//             <Card.StatCard
//               key={index}
//               label={city.city}
//               value={city.count}
//               color="#00000010"
//             />
//           ))
//         ) : (
//           <img src="/dataNotFound.png" alt="Data not found" />
//         )}
//       </ul>
//     </div>
//   );
// };
// const TopProducts = ({ title, products }) => {
//   console.log(
//     "City IS ====================================>>>>>>>>>>>>>>>",
//     products
//   );
//   return (
//     <div className="bg-white rounded-lg shadow-md p-3">
//       <h2 className="text-xl font-semibold mb-4">{title}</h2>

//       <ul className="flex flex-col gap-2">
//         {products && products.length > 0 ? (
//           products.map((product, index) => (
//             <Card.StatCard
//               key={index}
//               label={product.sku}
//               value={product.count}
//               color="#00000010"
//             />
//           ))
//         ) : (
//           <img src="/dataNotFound.png" alt="Data not found" />
//         )}
//       </ul>
//     </div>
//   );
// };

// const ActiveUserStates = ({ states }) => {
//   return (
//     <div className="bg-white rounded-lg shadow-md p-3">
//       <h2 className="text-xl font-semibold mb-4">States</h2>
//       <ul>
//         {states?.map((state, index) => (
//           <li key={index} className="flex items-center justify-between py-2">
//             <div className="flex items-center gap-3 w-full">
//               {/* <img
//                 src="https://loremflickr.com/200/200?random"
//                 alt={state.state}
//                 className="w-10 h-10 rounded-full"
//               /> */}
//               <div className="flex flex-col w-full">
//                 <div className="flex justify-between w-full">
//                   <div>{state?.state}</div>
//                   <div className="text-gray-700 text-sm items-center font-semibold">
//                     {state?.count}
//                   </div>
//                 </div>
//                 <div className="w-full bg-gray-100 h-2 rounded-full">
//                   <div
//                     className="bg-blue-500 h-2 rounded-full"
//                     style={{ width: `${state.percentage}%` }}
//                   ></div>
//                 </div>
//               </div>
//             </div>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// // Mock Data
// const topUserData = [
//   { name: "Louise L. Carleton", score: 1532 },
//   { name: "Carolyn", score: 243 },
//   { name: "Arun Kamboj", score: 22 },
//   { name: "Louise L. Carleton", score: 43 },
//   { name: "Alison", score: 43 },
// ];

// // const activeUserStatesData = [
// //   { state: "Uttar Pradesh", percentage: 72, image: "/images/up.png" },
// //   { state: "Madhya Pradesh", percentage: 44, image: "/images/mp.png" },
// //   { state: "Arunachal Pradesh", percentage: 32, image: "/images/ap.png" },
// //   { state: "Karnataka", percentage: 13, image: "/images/kt.png" },
// //   { state: "Himachal Pradesh", percentage: 4, image: "/images/hp.png" },
// // ];

// const BarCart = ({ data }) => {
//   return (
//     <div className={`shadow  rounded-lg w-full  bg-white/100  p-3 py-6`}>
//       <Line data={data} style={{ height: "", width: "" }} />
//     </div>
//   );
// };

import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { Bar } from "react-chartjs-2";
import { apiurl } from "../config/config";
import { useUser } from "../config/userProvider";
import { BlackButton } from "../components/buttonContainer";
import { InfiLoader } from "../components/loader";
import Card from "../components/card";

function Insight() {
  const { userData } = useUser();
  const vendorObjId = userData?.vendorDetails?.vendorObjId;

  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [parentFilterData, setParentFilterData] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [filter, setFilter] = useState("catalog_generated");
  const [filterLoading, setFilterLoading] = useState(false);

  // const filterHandler = () => {
  //   if (!vendorObjId) return;

  //   setFilterLoading(true);
  //   setLoading(true);

  //   const todayDate = new Date().toISOString().split("T")[0];

  //   const payload = {
  //     vendorObjId,
  //     type: filter || "catalog_generated",
  //     date: selectedDate || todayDate,
  //   };

  //   axios
  //     .post(`${apiurl}/admin/v1/analytic/insight`, payload)
  //     .then((response) => {
  //       if (response.data.success) {
  //         setFilterData(response.data.data);
  //         setParentFilterData(response.data.data);
  //       }
  //     })
  //     .catch((error) => console.error(error))
  //     .finally(() => {
  //       setLoading(false);
  //       setFilterLoading(false);
  //     });
  // };
  //   // Fetch initial data
  // useEffect(() => {
  //   filterHandler();
  // }, []);

  const filterHandler = useCallback(() => {
    if (!vendorObjId) return;

    setFilterLoading(true);
    setLoading(true);

    const todayDate = new Date().toISOString().split("T")[0];

    const payload = {
      vendorObjId,
      type: filter || "catalog_generated",
      date: selectedDate || todayDate,
    };

    axios
      .post(`${apiurl}/admin/v1/analytic/insight`, payload)
      .then((response) => {
        if (response.data.success) {
          setFilterData(response.data.data);
          setParentFilterData(response.data.data);
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setLoading(false);
        setFilterLoading(false);
      });
  }, [vendorObjId, filter, selectedDate]);

  useEffect(() => {
    filterHandler();
  }, [filterHandler]);

  const filterBy = (e) => {
    setFilter(e.target.value);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  // Store Data for Bar Chart
  let storeData = { labels: [], datasets: [] };

  if (filterData?.stores) {
    const stores = filterData.stores.map((store) => ({
      label: store.storeName || "Unknown",
      count: store.count || 0,
    }));

    // Ensure at least 5 entries
    while (stores.length < 5) {
      stores.push({ label: "xyz", count: 0 });
    }

    storeData = {
      labels: stores.slice(0, 5).map((s) => s.label),
      datasets: [
        {
          label: "Store Count",
          data: stores.slice(0, 5).map((s) => s.count),
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
          ],
          borderWidth: 1,
        },
      ],
    };
  }

  return (
    <Layout>
      <Container>
        {loading ? (
          <InfiLoader maintext="Fetching Insight Details..." />
        ) : (
          <div className="h-full">
            {/* Filter Section */}
            <FilterSection
              onClick={() => {}} // You can navigate to advanced report if needed
              filterHandler={filterHandler}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              filter={filter}
              setFilter={setFilter}
              filterLoading={filterLoading}
              filterBy={filterBy}
              handleDateChange={handleDateChange}
            />

            <div className="flex flex-col gap-3 overflow-auto h-[78%] lg:h-[90%] pb-3 mt-3">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                <TopUser title="Users" users={parentFilterData?.users} />
                <TopStates title="States" states={parentFilterData?.states} />
                <TopProducts
                  title="Products"
                  products={parentFilterData?.products}
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                <TopCity title="Cities" cities={parentFilterData?.cities} />

                <div className="col-span-2">
                  <div className="bg-white rounded-lg shadow-md p-3">
                    <h2 className="text-xl font-semibold mb-4">Stores</h2>
                    <div className="bg-white p-3 rounded-lg">
                      <Bar data={storeData} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </Layout>
  );
}

export default Insight;

// ====================== HELPER COMPONENTS ======================

const FilterSection = ({
  filterHandler,
  selectedDate,
  setSelectedDate,
  filter,
  setFilter,
  filterLoading,
  filterBy,
  handleDateChange,
}) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-md flex flex-wrap justify-between items-center gap-4">
      <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
        <div className="flex gap-3">
          <div className="border border-gray-300 rounded-md px-3 py-2">
            <input
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              className="outline-none text-sm md:text-base"
            />
          </div>

          <select
            value={filter}
            onChange={filterBy}
            className="bg-white border border-gray-300 text-gray-700 text-sm md:text-base px-4 py-2 rounded-md focus:outline-none capitalize"
          >
            <option value="">Filter By</option>
            <option value="order_placed">Orders</option>
            <option value="catalog_generated">Generated</option>
            <option value="catalog_downloaded">Downloaded</option>
            <option value="catalog_sent_email">Mail</option>
            <option value="catalog_sent_whatsapp">Whatsapp</option>
          </select>
        </div>

        {(selectedDate || filter) && (
          <BlackButton
            title="Apply"
            handleSubmit={filterHandler}
            loading={filterLoading}
            loadingTitle="Applying..."
            disabled={!selectedDate && !filter}
          />
        )}
      </div>

      {/* Advanced Filter Button (You can connect it later) */}
      <BlackButton title="Advanced Filter" handleSubmit={() => {}} />
    </div>
  );
};

const TopUser = ({ title, users }) => (
  <div className="bg-white rounded-lg shadow-md p-3">
    <h2 className="text-xl font-semibold mb-4">{title}</h2>
    <ul className="flex flex-col gap-2">
      {users?.length > 0 ? (
        users.map((user, index) => (
          <Card.StatCard
            key={index}
            label={user.userName}
            value={user.count}
            color="#00000010"
          />
        ))
      ) : (
        <img src="/dataNotFound.png" alt="No data found" className="mx-auto" />
      )}
    </ul>
  </div>
);

const TopStates = ({ title, states }) => (
  <div className="bg-white rounded-lg shadow-md p-3">
    <h2 className="text-xl font-semibold mb-4">{title}</h2>
    <ul className="flex flex-col gap-2">
      {states?.length > 0 ? (
        states.map((state, index) => (
          <Card.StatCard
            key={index}
            label={state.state}
            value={state.count}
            color="#00000010"
          />
        ))
      ) : (
        <img src="/dataNotFound.png" alt="No data found" className="mx-auto" />
      )}
    </ul>
  </div>
);

const TopCity = ({ title, cities }) => (
  <div className="bg-white rounded-lg shadow-md p-3">
    <h2 className="text-xl font-semibold mb-4">{title}</h2>
    <ul className="flex flex-col gap-2">
      {cities?.length > 0 ? (
        cities.map((city, index) => (
          <Card.StatCard
            key={index}
            label={city.city}
            value={city.count}
            color="#00000010"
          />
        ))
      ) : (
        <img src="/dataNotFound.png" alt="No data found" className="mx-auto" />
      )}
    </ul>
  </div>
);

const TopProducts = ({ title, products }) => (
  <div className="bg-white rounded-lg shadow-md p-3">
    <h2 className="text-xl font-semibold mb-4">{title}</h2>
    <ul className="flex flex-col gap-2">
      {products?.length > 0 ? (
        products.map((product, index) => (
          <Card.StatCard
            key={index}
            label={product.sku}
            value={product.count}
            color="#00000010"
          />
        ))
      ) : (
        <img src="/dataNotFound.png" alt="No data found" className="mx-auto" />
      )}
    </ul>
  </div>
);
